import {useContext, useEffect} from 'react';
import {ExperimentContext} from './index';
import {mixpanel} from '../../utils';
import {experimentSites, MIXPANEL_AB_TESTING} from '../../constants';

const ExperimentTracker = ({ enabled = true }) => {
    const experimentStatus = useContext(ExperimentContext);
    const variant = experimentStatus?.['Payment Portal AB Testing'];
    const variantName = variant?.SiteA ? experimentSites.SiteA
        : variant?.SiteB ? experimentSites.SiteB : null;

    useEffect(() => {
        if (!enabled) return;

        if (variantName) {
            mixpanel.track(MIXPANEL_AB_TESTING.startExperiment, {
                'Experiment name': 'Payment Portal AB Testing',
                'Variant Name': variantName
            });
        }
    }, [enabled, variantName]);

    return null;
};

export default ExperimentTracker;
